import React, { useEffect, useRef, useState } from "react";
import {
  DASHBOARD_MARKET_OPTIONS,
  useDashboardMarket,
} from "./DashboardMarketContext";
import "./DashboardMarketSelect.css";

const DashboardMarketSelect = ({ className = "" }) => {
  const { selectedMarket, setSelectedMarket } = useDashboardMarket();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedLabel =
    DASHBOARD_MARKET_OPTIONS.find((option) => option.key === selectedMarket)
      ?.label || "Futures";

  useEffect(() => {
    if (!isOpen) return;

    const handlePointerDown = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("pointerdown", handlePointerDown);
    return () => document.removeEventListener("pointerdown", handlePointerDown);
  }, [isOpen]);

  const selectMarket = (key) => {
    setSelectedMarket(key);
    setIsOpen(false);
  };

  return (
    <div
      className={`DashboardMarketSelect${isOpen ? " is-open" : ""}${
        className ? ` ${className}` : ""
      }`}
      ref={dropdownRef}
    >
      <button
        type="button"
        className="DashboardMarketSelect__btn"
        aria-label="Trade market"
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        onClick={() => setIsOpen((open) => !open)}
      >
        <span>{selectedLabel}</span>
        <span className="DashboardMarketSelect__caret" aria-hidden="true" />
      </button>

      {isOpen && (
        <ul className="DashboardMarketSelect__menu" role="listbox">
          {DASHBOARD_MARKET_OPTIONS.map((option) => (
            <li key={option.key}>
              <button
                type="button"
                role="option"
                aria-selected={selectedMarket === option.key}
                className={selectedMarket === option.key ? "is-active" : ""}
                onPointerDown={(event) => {
                  // Fire on pointerdown so the option isn't unmounted before click
                  // by the document outside-close listener.
                  event.preventDefault();
                  event.stopPropagation();
                  selectMarket(option.key);
                }}
              >
                {option.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DashboardMarketSelect;
